import DefsBlueprint from './../svg/defs'
import {default as GroupBlueprint, Controller as GroupController} from './../group';
import {extend, cloneObject} from './../../functions';
import SVGRenderer from './../../renderers/svg';
import state from './../../state';


class Controller extends GroupController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);
        this.type = 'svg';

        this.autoHeight = false;
        this.height = 0;
        this.contentHeight = 0;
        this.width = 0;

        this.svgRenderer = new SVGRenderer();
        this.svgRenderer.start(this);

    }

    // switch renderer, because the wrong one might be passed
    // on from the parent node.
    init(renderer){
        super.init(this.svgRenderer);
    }

    render(renderer){
        super.render(this.svgRenderer);
    }

    remove(renderer, removeFromParent=true){
        super.remove(this.svgRenderer, removeFromParent);
        this.svgRenderer.remove(false);
    }


    // todo: scaling svg to size of content with setSize(width, height)

    getSize(type='h'){

        let setting = type=='h'? this.data.height: this.data.width;

        if(setting == 'auto'){

            if(type == 'h' && this.contentHeight){
                setting = this.contentHeight;

            }else if(this.parent.renderOutput && this.parent.renderOutput.result){
                let elm = this.parent.renderOutput.result;
                setting = type == 'h'? elm.clientHeight: elm.clientWidth;   // dimension with padding

                if(!! window.getComputedStyle){
                    let cs = window.getComputedStyle(this.parent.renderOutput.result);
                    if(type == 'h'){
                        setting -= parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);
                    }else{
                        setting -= parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);
                    }
                }
            }

            if(setting){
                if(type == 'h'){
                    this.height = setting;
                }else{
                    this.width = setting;
                }
            }
        }else{
            if(type == 'h'){
                this.height = this.data.height;
            }else{
                this.width = this.data.width;
            }
        }
        return type == 'h' ? this.height: this.width;
    }

    getWidth(){
        return this.getSize('w');
    }

    getHeight(){
        return this.getSize('h');
    }

    setHeight(height){
        if(height && this.contentHeight != height){
            this.contentHeight = height;
            this.update();
        }
    }

}    


let SvgBlueprint = {
    type: Controller,
    properties: {
        style: {},
        attributes: {
            'width': (ctrl) => ( ctrl.getWidth() + 'px' ),
            'height': (ctrl) => ( ctrl.getHeight() + 'px' ), 
            'viewbox': (ctrl) => ( '0 0 ' + ctrl.getWidth() + 
                    ' ' + ctrl.getHeight() )
        },
        data: { 
            width: 'auto',
            height: 200
        }
    },
    listeners: [
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.update], 'windowSize') ),
    ],
    children: [
        cloneObject(DefsBlueprint),
        extend({
            properties: {
                data: { 
                    width: (ctrl) => (ctrl.parent.data.width ), 
                    height: (ctrl) => (ctrl.parent.data.height),
                    contentHeight: (ctrl) => (ctrl.parent.contentHeight)
                }
            }
        }, GroupBlueprint)
    ],
};


let SvgWrapper = function(InputBlueprint, extension=null){
    if(extension == null){
        extension = {
            uid: 'svg' + Math.floor(999999*Math.random())
        };
    }
    let svg = extend(extension, SvgBlueprint);
    if(! svg.children[1] || ! svg.children[1].children){
        svg.children[1] = cloneObject(SvgBlueprint.children[1]);
    }
    

    svg.children[1].children.push(extend({
        properties: {
            data: {
                svgUid: (ctrl) => ( ctrl.parent.parent.uid ),
                settings: (ctrl) => (ctrl.parent.parent.data)
            }
        }
    }, InputBlueprint));

    return svg;
}

export default SvgWrapper;